// extracted by mini-css-extract-plugin
export var formContainer = "_kn-0";
export var message = "_kn-1";